<template>
  <div class="sufee-login d-flex align-content-center flex-wrap">
    <div class="container">
      <div class="login-content">
        <!--<div class="login-logo">-->
        <!--<a href="index.html">-->
        <!--<img class="align-content" src="assets/logo.png" alt="">-->
        <!--</a>-->
        <!--</div>-->
        <div class="login-form">
          <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
          <!--<form>-->
          <div class="form-group">
            <label>{{$t('login.language')}}</label>
            <LngChooser/>
          </div>
          <div class="form-group">
            <label>{{$t('login.emailaddress')}}</label>
            <input @keyup="keymonitorNext" v-model="data.email" type="email" class="form-control" placeholder="" value="">
          </div>
          <div class="form-group">
            <label>{{$t('login.password')}}</label>
            <input @keyup="keymonitor" v-model="data.password" type="password" class="form-control" placeholder="" value="">
          </div>
          <div class="checkbox">
            <!--<label>-->
            <!--<input type="checkbox"> Remember Me-->
            <!--</label>-->
            <label class="pull-right">
              <!--<router-link to="/forgottenpassword" tag="a" class="">{{$t('login.forgottenpassword')}}</router-link>-->
            </label>

          </div>
          <button v-on:click="login()" class="btn-login btn btn-success btn-flat m-b-30 m-t-30">{{$t('login.submit')}}</button>
          <!--<div class="social-login-content">-->
          <!--<div class="social-button">-->
          <!--<button type="button" class="btn social facebook btn-flat btn-addon mb-3"><i class="ti-facebook"></i>Sign in with facebook</button>-->
          <!--<button type="button" class="btn social twitter btn-flat btn-addon mt-2"><i class="ti-twitter"></i>Sign in with twitter</button>-->
          <!--</div>-->
          <!--</div>-->
          <!--<div class="register-link m-t-15 text-center">-->
          <!--<p>Don't have account ? <a href="#"> Sign Up Here</a></p>-->
          <!--</div>-->
          <!--</form>-->

          <br>
          <!--{{process.env.VERSION}}-->
          <br>
          <div class="register-link m-t-15 text-center">
            <p>{{$t('login.dontrememberyourpassword')}}
              <router-link :to="{ path: '/remember'}"> {{$t('login.remember')}}</router-link>
            </p>
            <p>{{$t('login.donthaveanaccount')}}
              <router-link :to="{ path: '/register'}"> {{$t('login.register')}}</router-link>
            </p>
          </div>

        </div>
      </div>
    </div>
  </div>


</template>


<script>
  import Api from '@/api/Api';
  import LngChooser from '@/components/LngChooser.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Helper from '@/helper/Helper';
  import HelperRole from '@/helper/HelperRole';

  export default {
    name: 'Login',
    data() {
      return {
        data: {
          email: ""
          , password: ""
        }
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          delay: 5000,
        }

      };
    },
    mounted() {
      const modul = this;
      modul.$store.state.user = {};
      modul.$eventBus.$emit('HealthChecker', {status: false});
      Api.logout({}).then(function (e) {
        HelperRole.healthCheckClear(modul.$store.state)

//        if (e && e.result === true) {
//          // logged out
//        }
      });
    },
    methods: {
      keymonitorNext(event){
        const modul = this;
        if (event.key === "Enter") {
          document.querySelector('[type="password"]').focus();
        }
      },
      keymonitor(event){
        const modul = this;
        if (event.key === "Enter") {
          modul.login();
        }
      },
      login(){
        const modul = this;
        console.log("login")
        modul.$validator.validateAll().then((result) => {
          if (result) {
            const data = Helper.makeFilteredObjectByKeys(modul.data, ["email", "password"]);

            modul.AlertInPage.msg = "form.in_progress";
            modul.AlertInPage.type = "warning";

            Api.login(data).then(function (e) {
//              if (e && e.result === true) {
              if (e && e.token && e.token.accessToken && e.user) {
                if (e && e.token.accessToken) {
                  localStorage.setItem("accesstoken", e.token.accessToken);
                }
                if (e.user) {
                  modul.$store.state.user = e.user;
//                  console.log(e.user);
//                  console.log(modul.$store.state.user);
                }
                modul.AlertInPage.msg = "login.textsucces";
                modul.AlertInPage.type = "success";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                  // Redirect
                  console.log("redirect Login");
                  modul.$router.push({name: "dashboard"})
                }, Number(1000));
                modul.$eventBus.$emit('HealthChecker', {status: true});
              } else {
                if(e.message){
                  const text = e.message;
                  modul.AlertInPage.msg = ""+text;
                } else {
                  modul.AlertInPage.msg = "login.texterror";
                }
                modul.AlertInPage.type = "danger";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(5000));
              }
            }, function (e) {
              modul.AlertInPage.msg = "login.texterrorserver";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(5000));
            });

          } else {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
          }
        });
      }
    },
    components: {
      LngChooser
      , AlertInPage
    },
  };
</script>

